<template>
  <Layout>
    <Content :style="{'padding': '10px'}">
      <Breadcrumb :style="{margin: '5px 0'}">
        <BreadcrumbItem>人物管理 > <b>换脸人脸图片素材</b></BreadcrumbItem>
      </Breadcrumb>
      <Card>
		  <p :style="{'margin':'5px 10px 10px 20px','clear':'both','overflow':'hidden'}">
		  			<span :style="{'text-align':'center','float':'left'}">
		  				<Button type='primary' :style="{'margin-left':'5px'}" @click="addModal()">新增人脸图片素材</Button>
		  			</span>
		   </p>
        <Card id="tableContent" >
          <Table :columns="tableColumns" :data="huanlian_list"></Table>
		   <Page :total="recordTotal" :current="page" :page-size="10" :show-elevator="true" @on-change="getPicList"/>
        </Card>
      </Card>
    </Content>
	<Modal v-model="showmodal" :footer-hide=true  :scrollable=true title="合成图片及视频">
	     <Form ref="huanlian" :model="huanlian" :label-width="80" >
				<FormItem label="头像" prop="pic">
					<img :src="huanlian.pic" :style="{'width':'150px'}"/>
						<Upload :action="getUploadUrl" :headers="uploadHeader" :on-success="successCover">
				        <Button icon="ios-cloud-upload-outline">上传头像</Button>
				    </Upload>
				</FormItem>   
				<FormItem>
					<div style="border-bottom: 1px solid #e9e9e9;padding-bottom:6px;margin-bottom:6px;">
					        <Checkbox
					            :indeterminate="indeterminate"
					            :value="checkAll"
					            @click.prevent.native="handleCheckAll">全选，选择合成视频</Checkbox>
					    </div>
					<CheckboxGroup v-model="huanlian.select_video" @on-change="checkAllGroupChange">
					    <Checkbox :label="item.id" v-for="(item,index) in video_list" :key="index" v-show="item.split_video.length">
							<span><img :src="item.cover" width="50px"/></span>
						</Checkbox>
					</CheckboxGroup>
				</FormItem>
	         <FormItem>
	             <Button type="primary" @click="addPic()">提交图片</Button>
	         </FormItem>
	     </Form>
	 </Modal>
  </Layout>
</template>
<script>
import OSS from 'ali-oss';
	
export default {
  data(){
    return {
		search : {
			status:0
		},
		indeterminate: true,
		checkAll: false,
		showmodal:false,
		video_list:[],
		select_video_id:[],
		huanlian:{
			id:0,
			pic:"",
			select_video :[]
		},
		recordTotal:0,
		page:1,
		huanlian_list:[],
		tableColumns:[
		{ title: 'ID', key: 'id', align: 'center' },
		{ title: '头像', key: 'pic', align: 'center',
		render:(h,params) =>{
		   return h('img',{
			 attrs : {src : params.row.pic},
			 style : { width : '80px', height : '80px' }
		   })
		}},
		{ title: '换脸视频数量', key: 'pic', align: 'center',
		render:(h,params) =>{
			return h('span',{},params.row.video_id.length);
		 }},
		{ title: '已换脸数量', key: 'merger_total', align: 'center', render:(h,params) =>{
			 
			return h('span',{},params.row.merger_total);
		 }},
		 { title: '状态', key: 'status', align: 'center', render:(h,params) =>{
		 	 let sub_type = '未处理';
		     if (params.row.status == '0') {
		 		sub_type = '未提交';
		 	}else if (params.row.status == '1') {
		 		sub_type = '任务提交成功';
		 	}else if (params.row.status == '2') {
		 		sub_type = '任务提交失败';
		 	}
		 	return h('span',{},sub_type);
		  }},
		 { title: '操作', key: 'action', align: 'center',width: 200,
		   render: (h, params) => {
		 	let btns=[]
	
			if (params.row.status == '0') {
				btns.push(
					h('Button', {
					  props: { type: 'warning', size: 'small' },
					  style: { marginRight: '5px', marginBottom: '5px'},
					  on: {
						click: () => {      
							this.huanlian.id = params.row.id;
							this.huanlian.pic = params.row.pic;
							this.huanlian.select_video = params.row.video_id;
							this.showmodal = true;
						}
					  }
					}, '编辑'),
				);
			}
			if (params.row.status == '0' && params.row.video_id.length) {
				btns.push(
					h('Button', {
					  props: { type: 'error', size: 'small' },
					  style: { marginRight: '5px', marginBottom: '5px'},
					  on: {
						click: () => {      
							this.$Modal.confirm({
								content: '<p>确定要提交换脸操作吗？</p>',
								onOk: () => {
									this.changeFace(params.row.id);
								}
							});
						}
					  }
					}, '开始换脸'),
				);
			}
				
		 	return h("div",btns);
		   }
		 }
		],
		uploadHeader:{
		  "Authorization":localStorage.getItem('token')
		},
	}
  },
  mounted:function(){
	this.getPicList();
	this.getVideoList();
  },
  computed:{
	  getUploadUrl(){
	      return process.env.VUE_APP_APIHOST+'/admin/figure/upload';
	  }
  },
  methods:{
	  handleCheckAll () {
		  if (this.indeterminate) {
			  this.checkAll = false;
		  } else {
			  this.checkAll = !this.checkAll;
		  }
		  this.indeterminate = false;
		  if (this.checkAll) {
			  this.huanlian.select_video = this.select_video_id;
		  } else {
			  this.huanlian.select_video = [];
		  }
	  },
	  checkAllGroupChange (data) {
		  //console.log(data)
		  if (data.length === this.select_video_id.length) {
			  this.indeterminate = false;
			  this.checkAll = true;
		  } else if (data.length > 0) {
			  this.indeterminate = true;
			  this.checkAll = false;
		  } else {
			  this.indeterminate = false;
			  this.checkAll = false;
		  }
	  },
	addModal(){
		this.huanlian.id = 0;
		this.huanlian.pic = '';
		this.huanlian.select_video = [];
		this.showmodal = true;
	},
	getVideoList(page=this.page) {
		this.page = page;
		let p = {'page' : page,pagesize:50}
		let params = Object.assign(this.search, p);
		this.http.get('/admin/figure/aiVideo',{params:params}).then(response=>{
		  let data=response.data;
		  if(data.code!==0){
			alert(data.message);
		  } else{
			this.video_list = data.data.list;
			//所有id
			this.video_list.forEach((item,index)=>{
				this.select_video_id.push(item.id);
			})
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	},
	getPicList(page=this.page) {
		this.page = page;
		let p = {'page' : page}
		let params = Object.assign(this.search, p);
		this.http.get('/admin/figure/aiPic',{params:params}).then(response=>{
		  let data=response.data;
		  if(data.code!==0){
			alert(data.message);
		  } else{
			this.huanlian_list = data.data.list;
			this.recordTotal = data.data.total;
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	},
	addPic(){
		this.http.post('/admin/figure/facePic',this.huanlian).then(response=>{
		  let data=response.data;
		  if(data.code!==0) {
			this.$Message.error(data.message);
			return false;
		  } else{
			this.$Message.info(data.message);
			this.showmodal = false;
			this.getPicList(this.page);
			return true;
		  }
		});
	},
	changeFace(pic_id){
		this.http.post('/admin/figure/aiMerger',{pic_id:pic_id}).then(response=>{
		  let data=response.data;
		  if(data.code!==0) {
			this.$Message.error(data.message);
			return false;
		  } else{
			this.$Message.info(data.message);
			this.getPicList(this.page);
			return true;
		  }
		});
	},
	successCover(response, file, fileList){
	    let data=response
	    if(data.code!=0) {
	        this.$Message.error(data.message);
	        return true;
	    }
	    this.huanlian.pic = data.data.url;
		this.$Message.success('上传成功');
	},
  }
}
</script>
